var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterTwoC2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.4375V17.25",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.8553 4.875C0.94727 6.44776 0.583558 8.27619 0.820575 10.0767C1.05759 11.8772 1.88209 13.5493 3.16621 14.8335C4.45032 16.1176 6.12228 16.9422 7.9228 17.1794C9.72332 17.4165 11.5518 17.0529 13.1246 16.145C14.6974 15.237 15.9267 13.8355 16.6218 12.1577C17.3169 10.4799 17.439 8.61969 16.9691 6.86546C16.4992 5.11124 15.4636 3.56107 14.023 2.45536C12.5823 1.34966 10.8171 0.750219 9.00101 0.75V5.5625C9.75768 5.56267 10.4932 5.8125 11.0934 6.27326C11.6936 6.73401 12.125 7.37994 12.3208 8.11087C12.5165 8.8418 12.4656 9.61688 12.1759 10.3159C11.8862 11.015 11.374 11.5989 10.7186 11.9772C10.0633 12.3554 9.30146 12.5069 8.55126 12.4081C7.80107 12.3092 7.10444 11.9656 6.56942 11.4305C6.03439 10.8955 5.69087 10.1988 5.59213 9.44859C5.49338 8.69838 5.64493 7.93655 6.02327 7.28125L1.8553 4.875Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68047 9.89014L1.03125 11.1354",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTwoC2);
export default __webpack_public_path__ + "static/media/footer-two-c-2.3d5b844125974a773a10c246d1b4200e.svg";
export { ForwardRef as ReactComponent };